export const hasPermission = (permission) => {

    const permissions = JSON.parse(
        localStorage.getItem("permissions")
    ) || [];

    return permissions.includes(permission);
};



export const isManagement = () => {

    const role = localStorage.getItem("role");

    return (
        role === "Admin" ||
        role === "Management" ||
        role === "Principal"
    );
};



export const isTeacher = () => {

    const role = localStorage.getItem("role");

    return role === "Teacher";
};